module.exports = __webpack_public_path__ + "img/spring_compressed.prt.75b951be.jpg";